module.exports = __webpack_public_path__ + "media/Assignment_8.c423c830.mp4";